export default "__VITE_ASSET__CRbERsa1__"